<div class="bucket-widget" ng-if="!vm.widget.settingsVisible">
    <ul class="listing">
        <li ng-repeat="item in vm.items | orderBy: vm.widget.orderBy.value.predicate : vm.widget.orderBy.value.reverse">
            <div class="item-with-count">
                <span class="bucket-name">{{item.text}}</span><span class="count">{{item.count}}</span>
            </div>
        </li>
    </ul>
    <div class="total-count">
        <span class="title">{{"startPage.bucket.total" | translate}}</span>
        <div class="sum"><span class="sum"> {{vm.sum}}</span></div>
        <div class="spacer"></div>
    </div>
</div>
<div ng-if="vm.widget.settingsVisible" class="settingsContent properties">
    <div class="property-item">
        <label>{{"startPage.sort.order" | translate}}</label>
        <div c-select options="vm.widget.sorts" selected-option="vm.widget.orderBy"></div>
    </div>
</div>